import { IconButton } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import theme from "../theme";
import { RESPONSIVE_DRAWER } from "../common/Common.style";

const SCREEN_SIZE_SNACKBAR_KEY = "screen-size-warning";

export const useSupportedScreenSize = () => {
  const RECOMMENDED_WIDTH = RESPONSIVE_DRAWER.MIN_BP;
  const RECOMMENDED_HEIGHT = 720;
  const MIN_WIDTH = RESPONSIVE_DRAWER.MIN_BP;

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    let isSnackbarOpen = false;
    const checkResolution = () => {
      const width = window.innerWidth;

      if (!isSnackbarOpen && width < MIN_WIDTH) {
        enqueueSnackbar(
          `Best viewed at resolution ${RECOMMENDED_WIDTH} x ${RECOMMENDED_HEIGHT} or higher`,
          {
            key: SCREEN_SIZE_SNACKBAR_KEY,
            variant: "warning",
            autoHideDuration: null,
            preventDuplicate: true,
            action: () => (
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={() => closeSnackbar(SCREEN_SIZE_SNACKBAR_KEY)}
              >
                <CloseIcon
                  fontSize="small"
                  style={{ color: theme.palette.common.white }}
                />
              </IconButton>
            ),
          },
        );
        isSnackbarOpen = true;
      }
      if (isSnackbarOpen && width >= MIN_WIDTH) {
        closeSnackbar(SCREEN_SIZE_SNACKBAR_KEY);
        isSnackbarOpen = false;
      }
    };
    checkResolution();

    window.addEventListener("resize", checkResolution);

    return () => window.removeEventListener("resize", checkResolution);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
